<template>
    <div :class="['visual-flat', {'is-show': isReady}, {'is-iframe': visualInnerVersion}, mobileClass]">
        <Canvas modify="visual-canvas_page_floor"/>
        <Sly/>
        <Plan/>
        <Filters/>
    </div>
</template>

<style lang="scss">
    @import "./Flat.scss";
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
import Canvas from '../../components/Canvas/Canvas';
import Filters from '../../components/Filters/Filters';
import Plan from '../../components/Plan/Plan';
import Sly from '../../components/Sly/Sly';
import store from '../../store';
import {Utils} from 'common/scripts/utils';

export default {
    data() {
        return {
            mobileClass: ''
        };
    },

    components: {
        Canvas,
        Sly,
        Plan,
        Filters
    },

    computed: {
        ...mapGetters({
            isReady           : 'GET_IS_READY',
            visualInnerVersion: 'GET_VISUAL_VERSION'
        }),
    },

    created() {
        this._setMobileClass();

        window.addEventListener('orientationchange', this._setMobileClass.bind(this));
    },

    beforeDestroy() {
        window.removeEventListener('orientationchange', this._setMobileClass, false);
    },

    methods: {
        ...mapActions(['send']),

        _setMobileClass() {
            if (Utils.isMobile() && Utils.getWindowWidth() >= Utils.getWindowHeight()) {
                this.mobileClass = 'is-mobile-horizontal';
            } else {
                this.mobileClass = '';
            }
        }
    },

    beforeRouteEnter(to, from, next) {
        /**
         * Отправляет данные на сервер.
         */
        const body = {
            step    : 'flat',
            complex : to.params.complexId || false,
            building: to.params.buildingId,
            floor   : to.params.floorId,
            ...to.params
        };

        store.dispatch('send', {
            body,
            resetForm: false,
            query    : to.query
        }).then(() => {
            next();
        });
    }
};
</script>
